import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row list-unstyled mx-auto p-inline-start-0 ticket-tabs" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: index,
        class: _normalizeClass([{ 'active': tab.val === _ctx.activeTab }, "mr-2"])
      }, [
        _createElementVNode("button", {
          onClick: _withModifiers(($event: any) => (_ctx.$emit('changed', tab.val)), ["prevent"]),
          class: "btn d-flex align-items-center"
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["icon mr-2", _ctx.tabIcon(tab.val)]),
            "aria-hidden": "true"
          }, null, 2),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('common.ticketType.' + tab.val)) + " (" + _toDisplayString(tab.count) + ") ", 1)
        ], 8, _hoisted_2)
      ], 2))
    }), 128))
  ]))
}